import constants from '../../constants/constants'
import { Button, Form, Input, Modal, Table } from 'antd';
import { useState } from 'react';
import { COOKIE, getCookie } from '../../services/cookie';

const MyFlawsTable = ({ sectionData, handleAdd }) => {
	const loginType = getCookie(COOKIE.LoginType);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [form] = Form.useForm();
	const column = [
		{
			title: 'My Character Flaws',
			dataIndex: 'liability',
			key: 'liability',
		},
		{
			title: 'Assets',
			dataIndex: 'assest',
			key: 'assest',
		}
	];
	const add = () => {
		form.resetFields();
		setIsModalOpen(true);
	};
	const handleSave = async () => {
		const values = await form.validateFields();
		let tableDataSource = sectionData?.client_ans ? [...sectionData?.client_ans] : [];
		tableDataSource.push({
			assest: values.assest,
			liability: values.liability
		});
		let payload = {
			client_id: getCookie(COOKIE.ClientId),
			client_data: [{
				json_data: tableDataSource,
				item_id: sectionData?.item_id,
				section_id: sectionData?.section_id
			}]
		};
		handleAdd(payload).then((code) => {
			if (code === 200) {
				setIsModalOpen(false);
			} else {
				setIsModalOpen(true);
			}
		});
	};
	return (
		<div>
			<Button className='bg-sky-800 text-white uppercase text-xs font-semibold mt-2 mb-6'
				onClick={() => add()}
				disabled={loginType === "0" ? false : true}
			>
				{constants.Add}
			</Button>
			<div className='overflow-auto'>
				<Table
					rowClassName={() => 'editable-row'}
					bordered
					dataSource={sectionData?.client_ans || []}
					columns={column}
					pagination={false}
				/>
			</div>
			<Modal
				title="Add New Entry"
				open={isModalOpen}
				onCancel={() => setIsModalOpen(false)}
				onOk={handleSave}
				okText="Save"
				cancelText="Cancel"
			>
				<Form layout="vertical" form={form}>
					<Form.Item
						label="My Character Flaws"
						name="liability"
						rules={[{ required: true, message: "Please enter Character Flaw" }]}
					>
						<Input placeholder="Enter character flaw" />
					</Form.Item>

					<Form.Item
						label="Assets"
						name="assest"
						rules={[{ required: true, message: "Please enter Asset" }]}
					>
						<Input placeholder="Enter asset" />
					</Form.Item>
				</Form>
			</Modal>
		</div>
	)
}

export default MyFlawsTable